import Product from '~/models/Product'
import { Page } from '~/models/PaginatedItems'
import { BasePaginatedMemoryCache } from '~/passporter-services/basePaginatedMemoryCache'
import { ApiProductFilters } from '../itinerary/apiTypes'

export class ProductCache extends BasePaginatedMemoryCache<Product> {
	private FIVE_MINUTES_MS = 5 * 60 * 1000

	private getTripPageKey(tripId: string, filters: ApiProductFilters) {
		return `trip-${tripId}-${this.buildParamsKey(filters as Record<string, unknown>)}`
	}

	public setTripPage(
		tripId: string,
		productPage: Page<Product>,
		page: number,
		pageSize: number,
		filters: ApiProductFilters
	) {
		const key = this.getTripPageKey(tripId, filters)
		this.setPage(key, { ...productPage, page, pageSize }, this.FIVE_MINUTES_MS)
	}

	public getTripPage(
		tripId: string,
		page: number,
		pageSize: number,
		filters: ApiProductFilters
	): Page<Product> | undefined {
		const key = this.getTripPageKey(tripId, filters)
		return this.getPage(key, page, pageSize)
	}

	public deleteTripPages(tripId: string) {
		this.deleteManyThatStartWith(`trip-${tripId}-`)
	}
}
